<template>
	<div class="main" v-if="isShow">
		<div class="content">
			<div v-for="(item, index) in posters" :key="index">
				<van-swipe v-if="item.type === 'swipe'" class="my-swipe" :autoplay="3000" indicator-color="white">
					<van-swipe-item v-for="swipe in item.data" :key="swipe.url">
						<van-image class="poster" :src="swipe.url">
							<template v-slot:loading>
								<van-loading type="spinner" size="20" />
							</template>
							<template v-slot:error>
								<div class="error-image" @click="reloadPage">
									<img src="@/assets/pic_error.png" alt="" />
									<div>网络开小差了，图片加载失败</div>
									<div>请点击<span>刷新</span></div>
								</div>
							</template>
						</van-image>
					</van-swipe-item>
				</van-swipe>
				<van-image v-else lazy-load class="poster" :src="item.url">
					<template v-slot:loading>
						<van-loading type="spinner" size="20" />
					</template>
					<template v-slot:error>
						<div class="error-image" @click="reloadPage">
							<img src="@/assets/pic_error.png" alt="" />
							<div>网络开小差了，图片加载失败</div>
							<div>请点击<span>刷新</span></div>
						</div>
					</template>
				</van-image>
			</div>
		</div>
		<div class="apply-box">
			<div @click="apply" class="apply-btn">
				{{ activity.buttonText || "马上报名" }}
			</div>
		</div>
	</div>
</template>
<script>
import { getRecruitment } from "../../axios/Activity/index";
import { toQueryString } from "../../utils/tools";

export default {
	data() {
		return {
			posters: [],
			activity: {},
			queryString: "",
			isShow: false,
		};
	},
	mounted() {
		const query = this.$route.query || {};
		console.log(query);
		const { link_id: linkId } = query;
		delete query.link_id;
		this.queryString = toQueryString(query);
		this.$toast.loading({
			duration: 0, // 持续展示 toast
			forbidClick: true,
			message: "加载中",
		});
		getRecruitment({
			linkId,
		})
			.then(({ data, errcode, errmsg }) => {
				this.$toast.clear();
				if (errcode === 0) {
					const { linkDetailImg = "[]", linkCarouselImg = "[]" } = data;
					const posters = JSON.parse(linkDetailImg);
					const swipeImgs = JSON.parse(linkCarouselImg);
					if (swipeImgs.length > 0) {
						posters.splice(data.carouselImgOrder, 0, {
							type: "swipe",
							data: swipeImgs,
						});
					}
					this.posters = posters;
					this.activity = data;
					this.isShow = data.enableStatus === 1;
					if (!this.isShow) {
						this.$toast({
							message: "活动已失效",
							type: "fail",
						});
						return;
					}
					document.title = data.linkName;
				} else {
					return this.$toast({
						message: errmsg,
						type: "fail",
					});
				}
				console.log(data);
			})
			.catch(() => {
				this.$toast.clear();
			});
	},
	methods: {
		reloadPage() {
			window.location.reload();
		},
		apply() {
			const { linkId, linkUrl, linkName } = this.activity;
			const { activity_id, resource_id } = this.$route.query || {};
			const isActivity = activity_id && activity_id !== "0";
			const source_type = isActivity
				? "activity"
				: resource_id
					? "resource"
					: "";
			const source_id = isActivity ? activity_id : resource_id;
			this.$router.push({
				path: `/clue-input/?link_id=${linkId}&activity_url=${encodeURIComponent(
					linkUrl
				)}&activity_name=${encodeURIComponent(
					linkName
				)}&source_type=${source_type}&source_id=${source_id || ""}&${this.queryString
					}`,
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.content {
	height: calc(100vh - 80px);
	overflow: auto;
}

/deep/.van-image__error {
	width: 100%;
	height: 150px;
	position: relative;
}

.error-image {
	padding: 20px 0;
	display: flex;
	flex-direction: column;
	align-items: center;

	span {
		color: #456fee;
		padding: 0 5px;
	}
}

.poster {
	width: 100vw;
	margin: 0;
	padding: 0;
	outline: 0;
	vertical-align: top;
}

.van-swipe-item {
	color: #fff;
	font-size: 20px;
	text-align: center;
	background-color: #fff;
}

.apply-box {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100vw;
	height: 80px;
	box-sizing: border-box;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.2);
}

.apply-btn {
	display: inline-block;
	width: calc(100% - 80px);
	background: #456fee;
	font-size: 20px;
	color: #fff;
	text-align: center;
	line-height: 40px;
	height: 40px;
	border-radius: 30px;
}
</style>
